import { forwardRef, type Ref, type SVGProps } from "react";
const IconMessagePlusFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27 3H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h3v6a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l6.7-6.71H27a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m-7 10.5h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2" />
  </svg>
);
const ForwardRef = forwardRef(IconMessagePlusFilledSVG);
ForwardRef.displayName = "IconMessagePlusFilled";
export { ForwardRef as IconMessagePlusFilled };
